import React, { useState } from 'react';

import { BreadcrumbsV2 } from '@zola/zola-ui/src/components/BreadcrumbsV2';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import SubtopicChips from 'components/expert-advice/SubtopicChips';

import { SubtopicType, TopicType } from 'libs/contentful/types';
import { BreadcrumbV2LinkItemType } from '@zola/zola-ui/src/components/BreadcrumbsV2/BreadcrumbsV2';

import { BreadcrumbsContainer } from 'styles/expertAdviceShared.styles';
import {
  Subtitle,
  SubtitleContainer,
  SubtopicChipsContainer,
  SummaryHeaderContainer,
  Title,
  TitlesContainer,
  TopicLink,
} from './SummaryHeader.styles';

type SummaryHeaderProps = {
  breadcrumbs: BreadcrumbV2LinkItemType[];
  subtopic?: SubtopicType;
  topic: TopicType;
  topicHref: string;
};

const SummaryHeader = ({
  breadcrumbs,
  subtopic,
  topic,
  topicHref,
}: SummaryHeaderProps): JSX.Element => {
  const { description: subtopicDescription = '', name: subtopicName } = subtopic || {};
  const { description: topicDescription = '', name: topicName, subtopics = [] } = topic;
  const description = subtopicDescription || topicDescription;
  const name = subtopicName || topicName;
  const isSubtitleLong = Boolean(description.length > 172);
  const [truncated, setTruncated] = useState(isSubtitleLong);

  const toggleExpand = () => {
    setTruncated(!truncated);
  };

  return (
    <SummaryHeaderContainer>
      <BreadcrumbsContainer>
        <BreadcrumbsV2 currentSelectionLabel={name} linkItems={breadcrumbs} />
      </BreadcrumbsContainer>
      <TitlesContainer>
        {subtopic ? (
          <TopicLink href={topicHref} noUnderline noTextTransform subtle>
            {topicName}
          </TopicLink>
        ) : (
          <></>
        )}
        <Title presentation="h3">{name}</Title>
        {description.length > 0 ? (
          <SubtitleContainer truncated={truncated}>
            <Subtitle presentation="h6" truncated={truncated}>
              {description}
            </Subtitle>{' '}
            {isSubtitleLong ? (
              <LinkV2 onClick={toggleExpand} role="button">
                {truncated ? 'More' : 'Less'}
              </LinkV2>
            ) : (
              <></>
            )}
          </SubtitleContainer>
        ) : (
          <></>
        )}
      </TitlesContainer>
      {subtopics.length > 0 ? (
        <SubtopicChipsContainer>
          <SubtopicChips subtopics={subtopics} topicHref={topicHref} />
        </SubtopicChipsContainer>
      ) : (
        <></>
      )}
    </SummaryHeaderContainer>
  );
};

export default SummaryHeader;
